<template>
  <div class="channel-flow-step-wrapper">
    <p class="channel-flow-description">
      {{getTranslations("expression_1358")}}
      <strong>{{ getDisplayChannelName }}</strong>.
      {{getTranslations("expression_1359")}}
    </p>

    <!-- Nome da Empresa -->
    <div class="channel-flow-form-group">
      <label for="company-name" class="channel-flow-label"> {{getTranslations("expression_1353")}} <span class="required">*</span></label>
      <input 
        id="company-name"
        v-model="localCompanyInfo.name" 
        @input="updateCompanyInfo" 
        type="text" 
        class="channel-flow-input" 
        :placeholder="getTranslations('expression_1362')"
        required 
      />
    </div>

    <!-- Equipe -->
    <div class="channel-flow-form-group">
      <label for="team-input" class="channel-flow-label">{{getTranslations("expression_12")}}<span class="required">*</span></label>
      <div class="channel-flow-team-container">
        <input 
          id="team-input"
          v-model="newTeam" 
          type="text"
          class="channel-flow-input"
           :placeholder="getTranslations('expression_1360')"
          @keydown.enter.prevent="handleAddTeam" 
        />
        <button @click="handleAddTeam" class="channel-flow-add-team-btn">{{getTranslations("expression_693")}}</button>
      </div>

      
      <!-- Exibir equipes adicionadas -->
        <div v-if="localCompanyInfo.teams.length > 0" class="channel-flow-team-list-wrapper">
          <label class="channel-flow-label"> {{getTranslations("expression_1354")}}:</label>
          <ul class="channel-flow-team-list">
            <li
              v-for="(team, index) in localCompanyInfo.teams"
              :key="index"
              class="channel-flow-team-item"
            >
              <span class="channel-flow-team-name">{{ team.name }}</span>
              <button @click="removeTeam(index)" class="channel-flow-remove-btn">
                <XIcon class="channel-flow-remove-icon" />
                <span class="sr-only"> {{getTranslations("expression_1355")}} {{ team.name }}</span>
              </button>
            </li>
          </ul>
        </div>

    </div>
      
    <!-- Setor de Atuação -->
    <div class="channel-flow-form-group">
      <label for="sector" class="channel-flow-label"> {{getTranslations("expression_1356")}}</label>
      <div class="channel-flow-select-wrapper">
        <select 
          id="sector" 
          v-model="localCompanyInfo.sector" 
          @change="updateCompanyInfo" 
          class="channel-flow-select"
        >
          <option value="" disabled> {{getTranslations("expression_1357")}}</option>
          <option v-for="sector in sectors" :key="sector" :value="sector">{{ sector }}</option>
        </select>
      </div>
    </div>
  </div>
</template>


<script>
import { X as XIcon } from "lucide-vue";
import "../../../../js/assets/css/Channel-Flow/channel-flow.css"
export default {
  components: {
    XIcon
  },
  props: {
    value: {
      type: Object,
      default: () => ({ name: "", teams: [] })
    },
    sectors: {
      type: Array,
      default: () => []
    },
    selectedChannel: {
      type: Object,
      default: () => ({ name: "", type_key: null })
    }
  },
  computed: {
    localCompanyInfo: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    getDisplayChannelName() {
      if (!this.selectedChannel || !this.selectedChannel.name) return "______";
      const nameMap = {
        Messenger: "Facebook",
        Telegram: "WhatsApp Cloud API",
        WhatsApp: "WhatsApp Web"
      };
      return nameMap[this.selectedChannel.name] || this.selectedChannel.name;
    }
  },
  data() {
    return {
      newTeam: ""
    };
  },
  methods: {
    handleAddTeam() {
      const teamName = this.newTeam.trim();

      if (!teamName) {
        this.$toast.error(getTranslations("expression_1360"));
        return;
      }

      const teamExists = this.localCompanyInfo.teams.some(
        (team) => team.name.toLowerCase() === teamName.toLowerCase()
      );

      if (teamExists) {
        this.$toast.error(getTranslations("expression_1361"));
        return;
      }

      this.localCompanyInfo.teams.push({ name: teamName });
      this.newTeam = "";
    },

    removeTeam(index) {
      this.localCompanyInfo.teams.splice(index, 1);
    },
    
  }
};
</script>





